// extracted by mini-css-extract-plugin
export default {"cookie-card":"index-module__cookie-card___ayR98","cookieCard":"index-module__cookie-card___ayR98","button":"index-module__button___B6H_m"};